export const enum CreateEventPaymentError {
  EventSoldOut = 'event_sold_out',
  // May add future cases here
}
